import { useLaboratories } from './useLaboratories'

export default useLaboratories
